"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breakpoints = void 0;
var Breakpoints = {
  DESKTOP: 1024
};
exports.Breakpoints = Breakpoints;